import { render } from "./sjyj.vue?vue&type=template&id=63b4453e&scoped=true"
import script from "./sjyj.vue?vue&type=script&lang=js"
export * from "./sjyj.vue?vue&type=script&lang=js"

import "./sjyj.vue?vue&type=style&index=0&id=63b4453e&scoped=true&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b4453e"]])

export default __exports__